import NextImage from "next/image";
import styled from "@mui/material/styles/styled";

const LazyImage = styled(NextImage)({
  height: "auto",
  padding: "10px",
});

export default LazyImage;
